import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "posRe w100 fs12 fw600 dgrey" }
const _hoisted_2 = { class: "parentCalendarContent" }
const _hoisted_3 = {
  class: "fl posRe",
  style: `height:100px;width:100px;`
}
const _hoisted_4 = { class: "fr" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "fs11 fw600 dgrey"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = {
  key: 1,
  class: ""
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  class: "posRe fl ofh",
  style: {"width":"calc(100% - 100px)","height":"80px"}
}
const _hoisted_12 = {
  key: 0,
  class: ""
}
const _hoisted_13 = { style: {"margin-left":"4px"} }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "fs11" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { key: 1 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "fs12" }, "予定あり", -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MemberDailyLinePerCalendarTag = _resolveComponent("MemberDailyLinePerCalendarTag")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alldayEvents, (event, alldayindex) => {
            return (_openBlock(), _createElementBlock("div", { key: alldayindex }, [
              _withDirectives(_createElementVNode("div", {
                class: _normalizeClass(`${event.ignore_allday ? `orangePinkBg` : `blackbrownBg`} rad6 fr`),
                style: {"width":"12px","height":"12px","margin-right":"10px"}
              }, null, 2), [
                [_directive_tooltip, 
                                `${event.title ? `${event.title}` : `終日予定あり`}${event.location ? `@${event.location}` : ``}`
                            ]
              ])
            ]))
          }), 128))
        ]),
        _hoisted_5,
        (!_ctx.pdc.hideMemberName)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
              _createTextVNode(_toDisplayString(_ctx.member.is_company ? _ctx.member.company_name : ``) + " ", 1),
              _hoisted_7,
              _createTextVNode(" " + _toDisplayString(_ctx.member.name), 1)
            ]))
          : _createCommentVNode("", true),
        _hoisted_8,
        (_ctx.myAttendee && _ctx.member.user_group_id == _ctx.myAttendee.user_group_id && _ctx.magsNum && _ctx.pd && !_ctx.pdc.hideMemberName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_ctx.selectedMagEventsDic)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(`w95 circle_button fw400 fl centered fs10 blueAround mt5 mb5`),
                    style: {"padding":"1px 10px"},
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeMag && _ctx.closeMag(...args)))
                  }, " 閉じる "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pd.ok_groups, (groupId, groupindex) => {
                return _withDirectives((_openBlock(), _createElementBlock("p", {
                  class: _normalizeClass(`fl pointer circleBlueButton ${_ctx.magId == groupId ? `selected` : ``} small mr2`),
                  key: groupindex,
                  onClick: ($event: any) => (_ctx.openGroup(groupId))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.mag_dic[groupId].name), 1)
                ], 10, _hoisted_10)), [
                  [
                    _directive_tooltip,
                    
                            _ctx.dailyEventsInfo.group_events_dic && _ctx.dailyEventsInfo.group_events_dic[groupId]
                                ? _ctx.dailyEventsInfo.group_events_dic[groupId].team_name
                                : null
                        ,
                    void 0,
                    { bottom: true }
                  ]
                ])
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", {
          class: _normalizeClass(`w100 rad4 posAb ${_ctx.member.user_id == _ctx.rm.userInfo.user_id ? `lyellowgreyBg` : `lgreyBlueBg`}`),
          style: {"height":"80px"}
        }, null, 2),
        (_ctx.currentEventsDic)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentEventsDic.possible_events, (avzone, poseventIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${avzone.type}${avzone.start_time}${poseventIndex}`
                }, [
                  _createElementVNode("div", {
                    class: "posAb orangePinkBg availableEvent rad5 ofh",
                    style: _normalizeStyle(`opacity:0.8;height:80px; width: ${(avzone.duration / 60) * 60}px;left: ${
                                (avzone.start_hour - 8 + avzone.start_min / 60) * 60
                            }px;`)
                  }, null, 4)
                ]))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentEventsDic.events, (event, evindex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${event.type}${event.start_time}${evindex}${_ctx.currentEventsDic.events.length}`
                }, [
                  (!event.allday)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "posAb blackbrownBg pad2 availableEvent rad5 ofh",
                        style: _normalizeStyle(`height:80px; width: ${(event.duration / 60) * 60}px;left: ${
                                (event.start_hour - 8 + event.start_min / 60) * 60
                            }px;`)
                      }, [
                        _createElementVNode("span", _hoisted_13, [
                          (_ctx.dailyEventsInfo.event_readable)
                            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("span", _hoisted_15, _toDisplayString(event.title), 1),
                                (event.location)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, "@" + _toDisplayString(event.location), 1))
                                  : _createCommentVNode("", true),
                                _hoisted_17
                              ])), [
                                [_directive_tooltip, `${event.title}${event.location ? `@${event.location}` : ``}`]
                              ])
                            : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                        ])
                      ], 4))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_21
    ]),
    (_ctx.magsNum && _ctx.pdc.openDetailSchedules && _ctx.selectedMagEventsDic)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedMagEventsDic.events_cal_id_dic, (events, calId, calindex) => {
            return (_openBlock(), _createBlock(_component_MemberDailyLinePerCalendarTag, {
              key: `${calId}${events.length}${calindex}`,
              events: events,
              calId: calId,
              magId: _ctx.magId,
              calindex: calindex,
              mag_dic: _ctx.mag_dic,
              dailyEventsInfo: _ctx.dailyEventsInfo,
              possible_events: _ctx.selectedMagEventsDic.possible_events_cal_id_dic[calId],
              currentTime: _ctx.currentTime,
              myAttendee: _ctx.myAttendee,
              duration: _ctx.duration
            }, null, 8, ["events", "calId", "magId", "calindex", "mag_dic", "dailyEventsInfo", "possible_events", "currentTime", "myAttendee", "duration"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}